import React from "react";

const MembersSettingsPopUp = ({
  setMembersSettingsPopUp,
  membersSettingsPopUp,
  setActiveChat,
  activeChatRef,
  emitWithAck,
  setListOfMessagesAndInfo,
  setChats,
  SetSelectedValues,
}) => {
  const removeMember = async () => {
    try {
      const data = await emitWithAck("group:removeMembers", {
        memberId: membersSettingsPopUp._id,
        memberName: membersSettingsPopUp.username,
        memberEmail: membersSettingsPopUp.email,
        groupId: membersSettingsPopUp.groupId,
      });

      setChats((prev) => {
        const target = prev.find(
          (friendInfo) => friendInfo?.group?._id === data.group._id,
        );
        const rest = prev.filter((friendInfo) => {
          if (friendInfo?.friend) return true;
          return friendInfo?.group?._id !== data.group._id;
        });
        return [
          {
            ...target,
            group: {
              ...target.group,
              admin: data.group.admin,
              participants: data.group.participants,
              allParticipants: data.group.allParticipants,
            },
            lastMessage: data.lastMessage,
          },
          ...rest,
        ];
      });

      setActiveChat((prev) => {
        return {
          ...prev,
          email: data.group.participants
            .map((participant) => participant.username)
            .join(","),
          participants: data.group.participants,
          participantIds: data.group.participants.map(
            (participant) => participant._id,
          ),
          admin: data.group.admin,
          allParticipants: data.group.allParticipants,
        };
      });

      setListOfMessagesAndInfo((prev) => {
        return {
          ...prev,
          messages: [...prev.messages, data.lastMessage],
        };
      });

      setMembersSettingsPopUp(null);
    } catch (err) {
      alert(err.message);
    }
  };

  const changeStatus = async () => {
    try {
      const data = await emitWithAck("group:memberStatusChange", {
        memberId: membersSettingsPopUp._id,
        status: membersSettingsPopUp.value,
        groupId: membersSettingsPopUp.groupId,
      });

      SetSelectedValues((prev) => {
        const next = [...prev];
        next[membersSettingsPopUp.index] = data.group.status;
        return next;
      });

      setChats((prev) => {
        return prev.map((friendInfo) => {
          if (friendInfo?.friend) return friendInfo;
          if (friendInfo?.group?._id !== data.group._id) return friendInfo;
          return {
            ...friendInfo,
            group: {
              ...friendInfo.group,
              admin: data.group.admin,
            },
          };
        });
      });

      setActiveChat((prev) => {
        return {
          ...prev,
          admin: data.group.admin,
        };
      });

      setMembersSettingsPopUp(null);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      onClick={() => setMembersSettingsPopUp(null)}
      className="fixed inset-0 bg-black/80 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[40dvw] h-[20dvh] bg-white p-4"
      >
        {membersSettingsPopUp.type === "status" ? (
          membersSettingsPopUp.value === "zero admin problem" ? (
            <div>
              As there is only one admin, you cannot change your status unless
              you make someone else an admin
            </div>
          ) : (
            <>
              <div>
                Are you sure you want to change status of "
                {membersSettingsPopUp.username}" to "
                {membersSettingsPopUp.value}"?
              </div>
              <div className="flex justify-end items-center gap-1">
                <button
                  onClick={() => setMembersSettingsPopUp(null)}
                  className="border border-gray-400 p-1"
                >
                  Cancel
                </button>
                <button onClick={changeStatus} className="bg-orange-400 p-1">
                  Yes
                </button>
              </div>
            </>
          )
        ) : (
          <>
            <div>
              Are you sure you want to remove "{membersSettingsPopUp.username}"
              from this group?
            </div>
            <div className="flex justify-end items-center gap-1">
              <button
                onClick={() => setMembersSettingsPopUp(null)}
                className="border border-gray-400 p-1"
              >
                Cancel
              </button>
              <button onClick={removeMember} className="bg-orange-400 p-1">
                Yes
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MembersSettingsPopUp;
